/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { IdTitleReferenceId } from './idTitleReferenceId';
import type { IdTitleReferenceTitle } from './idTitleReferenceTitle';

/**
 * Reference to an object by id and title
 */
export interface IdTitleReference {
  id?: IdTitleReferenceId;
  title?: IdTitleReferenceTitle;
}
